const types = {
	//Get Template name
	GET_PLAN_TRAINING_START: "GET_PLAN_TRAINING_START",
	GET_PLAN_TRAINING_SUCCESS: "GET_PLAN_TRAINING_SUCCESS",
	GET_PLAN_TRAINING_ERROR: "GET_PLAN_TRAINING_ERROR",
	GET_PLAN_TRAINING_RESET: "GET_PLAN_TRAINING_RESET",

	//Create Template name
	CREATE_PLAN_TRAINING_START: "CREATE_PLAN_TRAINING_START",
	CREATE_PLAN_TRAINING_SUCCESS: "CREATE_PLAN_TRAINING_SUCCESS",
	CREATE_PLAN_TRAINING_ERROR: "CREATE_PLAN_TRAINING_ERROR",
	CREATE_PLAN_TRAINING_RESET: "CREATE_PLAN_TRAINING_RESET",

	//delete Template name
	DELETE_PLAN_TRAINING_START: "DELETE_PLAN_TRAINING_START",
	DELETE_PLAN_TRAINING_SUCCESS: "DELETE_PLAN_TRAINING_SUCCESS",
	DELETE_PLAN_TRAINING_ERROR: "DELETE_PLAN_TRAINING_ERROR",
	DELETE_PLAN_TRAINING_RESET: "DELETE_PLAN_TRAINING_RESET",

	//update Template name
	UPDATE_PLAN_TRAINING_START: "UPDATE_PLAN_TRAINING_START",
	UPDATE_PLAN_TRAINING_SUCCESS: "UPDATE_PLAN_TRAINING_SUCCESS",
	UPDATE_PLAN_TRAINING_ERROR: "UPDATE_PLAN_TRAINING_ERROR",
	UPDATE_PLAN_TRAINING_RESET: "UPDATE_PLAN_TRAINING_RESET",

	//single item  name
	SINGLE_PLAN_TRAINING_START: "SINGLE_PLAN_TRAINING_START",
	SINGLE_PLAN_TRAINING_SUCCESS: "SINGLE_PLAN_TRAINING_SUCCESS",
	SINGLE_PLAN_TRAINING_ERROR: "SINGLE_PLAN_TRAINING_ERROR",
	SINGLE_PLAN_TRAINING_RESET: "SINGLE_PLAN_TRAINING_RESET",
};

export default types;
